import classnames from 'classnames'
import React from 'react'
import { isNil } from 'lodash'
import { Input } from 'reactstrap'

import { DropdownOption, DropdownProps } from './types'

export const DropdownComponent = ({className, data, disabled, onChange, selected}: DropdownProps) => {
  return <Input disabled={disabled}
                className={classnames('dropdown-component', className || '')}
                type="select"
                value={isNil(selected) ? data[0].key : selected}
                onChange={
                      (e) => {
                        // tslint:disable-next-line
                        const selectedOption = data.find((d: DropdownOption) => d.key == e.target.value && !d.divider)
                        if (selectedOption) {
                          onChange({selected: selectedOption})
                        }
                      }
                }>
    {data.map((d, i) =>
      <option key={`dropdown-key-${d.key}`} value={d.key} className={d.divider ? 'divider' : 'option'}>
        {d.description || d.key}
      </option>)}
  </Input>
}
